// Scroll unificado del shell de la app.
//
// La app tiene DOS contenedores de scroll según el viewport (ver
// `ScrollToTop.tsx` y el DashboardLayout en `App.tsx`):
//   • mobile (< md/768px) → scrollea el documento (window / html-body).
//   • desktop (md+)       → scrollea el panel de contenido fijo
//     `.content-panel-clip` (`md:fixed md:overflow-y-auto`), NO el
//     documento — ahí `window.scrollY` es SIEMPRE 0 y `window.scrollTo`
//     no hace nada.
//
// Cualquier save/restore de scroll de página tiene que pasar por estos
// helpers; leer `window.scrollY` a mano es un bug latente en desktop.

const getPanel = (): HTMLElement | null =>
  document.querySelector<HTMLElement>('.content-panel-clip');

/** Posición de scroll actual, sea cual sea el scroller activo. Solo uno
 *  de los dos puede ser distinto de 0, así que el máximo es el real. */
export const getAppScrollY = (): number => {
  const panel = getPanel();
  return Math.max(window.scrollY, panel ? panel.scrollTop : 0);
};

/** Scrollea la app a `top` — setea ambos scrollers (el inactivo lo
 *  ignora porque no tiene overflow). */
export const setAppScrollY = (
  top: number,
  behavior: ScrollBehavior = 'auto',
): void => {
  try {
    window.scrollTo({ top, behavior });
    document.documentElement.scrollTo({ top, behavior });
  } catch {
    window.scrollTo(0, top);
  }
  const panel = getPanel();
  if (panel) {
    try {
      panel.scrollTo({ top, behavior });
    } catch {
      panel.scrollTop = top;
    }
  }
};

/** Posición (en coordenadas del scroller activo) del tope de `el`, para
 *  scrollear hasta él con `setAppScrollY`. */
export const getAppScrollYFor = (el: HTMLElement): number => {
  const rectTop = el.getBoundingClientRect().top;
  const panel = getPanel();
  if (panel && window.matchMedia('(min-width: 768px)').matches) {
    return panel.scrollTop + rectTop - panel.getBoundingClientRect().top;
  }
  return window.scrollY + rectTop;
};
